import React from "react"
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

/**
 * Hero + stats — src/Design/industries/industry-*.html, SECTION 1.
 *
 * The <h1> holds two block-level lines: kicker (small, muted, sentence
 * case — the customer's situation, never a product name) and headline (the
 * result they want). Photo is full-bleed on the right, from under the
 * header to the stats row; text starts at the header logo's own left edge.
 * .ihero-block wraps hero + stats so the pair fills the screen below the
 * header together (capped at 1080px), stats flush at the bottom.
 */
const IndustryHero = ({
  industryName,
  kicker,
  headline,
  subheading,
  heroImage,
  heroImageAlt,
  ctaHref,
  ctaLabel,
  badge,
  stats = [],
}) => (
  <div className="ihero-block">
    <section className="ihero">
      <div className="ihero__inner">
        <div className="ihero__content">
          <nav className="ihero__crumbs" aria-label="Breadcrumb">
            <Link to="/">Home</Link>
            <span aria-hidden="true"> / </span>
            <span>{industryName}</span>
          </nav>

          <h1 className="ihero__heading">
            <span className="ihero__kicker">{kicker}</span>
            <span className="ihero__headline">{headline}</span>
          </h1>

          <p className="ihero__subhead">{subheading}</p>

          <div className="ihero__ctas">
            <Link to={ctaHref} className="ihero__btn">
              {ctaLabel}
            </Link>
          </div>
        </div>
      </div>

      <div className="ihero__media">
        {heroImage ? (
          <GatsbyImage
            image={heroImage}
            alt={heroImageAlt || ""}
            className="ihero__photo"
            loading="eager"
            fetchpriority="high"
          />
        ) : (
          <div className="ihero__photo ihero__photo-placeholder" aria-hidden="true" />
        )}

        {badge && (
          <div className="ihero__badge">
            <span className="ihero__badge-dot" aria-hidden="true" />
            {badge}
          </div>
        )}
      </div>
    </section>

    {stats.length > 0 && (
      <section className="ihero-stats">
        <div className="ihero-stats__inner">
          {stats.map(s => (
            <div className="ihero-stats__stat" key={s.label}>
              <span className={`ihero-stats__value${s.long ? " ihero-stats__value--long" : ""}`}>{s.value}</span>
              <span className="ihero-stats__label">{s.label}</span>
            </div>
          ))}
        </div>
      </section>
    )}
  </div>
)

export default IndustryHero
